import React, { useContext } from 'react';

import ReportContext from 'contexts/ReportContext';
import { QuickFilter } from '../../CustomerLaneCommitsBoard/QuickFilters/QuickFilters';

const ReportQuickFiltersDisplay = () => {
  const {
    report,
    quickFilters,
    selectedQuickFilters,
    setSelectedQuickFilters,
  } = useContext(ReportContext);
  const quickFilterOrder = report?.quickFilterOrder || [];

  const onFilterToggled = (filter: LegacySavedFilter) => {
    const isSelected = selectedQuickFilters.some((f) => f.id === filter.id);
    if (isSelected) {
      setSelectedQuickFilters((fs) => fs.filter((f) => f.id !== filter.id));
    } else {
      setSelectedQuickFilters((fs) => [...fs, filter]);
    }
  };

  // quickFilterOrder may reference IDs for filters that have since been deleted.
  // Filter those out, then append any filters missing from the order array at the end.
  const orderedFilters = quickFilterOrder
    .map((filterId) => quickFilters.find((f) => f.id === filterId))
    .filter((f): f is LegacySavedFilter => !!f);
  const filtersNotInOrder = quickFilters.filter(
    (f) => !quickFilterOrder.includes(f.id),
  );
  orderedFilters.push(...filtersNotInOrder);

  // Fragment (not a wrapper div) so pills are direct flex children of the
  // LeftGroup in Report.tsx and participate in its flex-wrap layout.
  return (
    <>
      {orderedFilters.map((f) => (
        <QuickFilter
          key={f.id}
          onClick={() => onFilterToggled(f)}
          isSelected={selectedQuickFilters.some((sf) => sf.id === f.id)}
          name={f.name || 'Filter'}
        />
      ))}
    </>
  );
};

export default ReportQuickFiltersDisplay;
